export const NO_LABEL = 'Aucun';
export const RESET_TRACKS_MODE = 'reset_tracks_mode';
